import { SimulatorChannel } from "@/v2/entities/simulator/Simulator.model";

export interface AgentChannel {
    channel: SimulatorChannel;
    count: number;
}

export interface TenantStatisticsApiResponse {
    tenantId: string;
    aiAgentsPublished: number;
    aiAgentsChannels: AgentChannel[];
    topicsReleased: number;
    topicsTotal: number;
    ticketsReleasedPercentage: number;
    ticketsHandledByQuackFromReleasedPercentage: number;
    ticketsHandledByQuackFromAllPercentage: number;
    skillsConfigured: number;
    skillsReleased: number;
}

export const channelLabels: Record<SimulatorChannel, string> = {
    autonomous_ticket_event: "Tickets",
    autonomous_quackchat: "Live Chat",
    helpcenter: "Help Center",
    slackbot: "Slackbot",
    copilot: "Copilot",
    knowledge_hub: "Knowledge Hub",
};
